/**
 * bootstrap.js
 */
import axios from 'axios';
// axios
axios.defaults.headers.common['Access-Control-Max-Age'] = '86400';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;

// let token = document.head.querySelector('meta[name="csrf-token"]');
// if (token) {
//     axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
// }

// Plugins
//window.alertify = require('alertifyjs');
//window.TWzipcode = require('./twzipcode');
//import TWzipcode from './twzipcode';
import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';
import Toast from 'primevue/toast';
import KeyFilter from 'primevue/keyfilter';
import ToastService from 'primevue/toastservice';
import Ripple from 'primevue/ripple';
import DialogService from 'primevue/dialogservice';
import ConfirmationService from 'primevue/confirmationservice';
import Aura from '@primevue/themes/aura';
import pinia from './pinia';
import Navbar from './vue/views/layouts/navbar.vue';
//import Material from '@primevue/themes/material';

export function mountNavbar() {
    const app = createApp({});
    setupApp(app).component('app-navbar', Navbar).mount('#nav-app-v2');
};

// Other Apps
export function setupApp(app) {

    // 註冊全局組件
    app.component('Toast', Toast);

    // 使用插件
    app.use(PrimeVue, {
        pt: {
            toast: {
                root: {
                    style: 'max-width: calc(100vw - 40px);'
                }
            },
        },
        theme: {
            preset: Aura,
            options: {
                prefix: 'p',
                darkModeSelector: 'system',
                cssLayer: false
            }
        }
    })
    .use(pinia)
    .use(ToastService)
    .use(DialogService)
    .use(ConfirmationService);

    // 註冊指令
    app.directive('tooltip', Tooltip)
        .directive('keyfilter', KeyFilter)
        .directive('ripple', Ripple);

    return app;
}



